import axios from 'axios';

const HOSTAPI = process.env.REACT_APP_BASE_URL;

const DeleteMeetingStatusRedis = async (payload: any): Promise<{ status: number; data: any }> => {
  try {
    const response = await axios.post(`${HOSTAPI}/connection/deleteMeetingLive`, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error: any) {
    return {
      status: error.response?.status || 500,
      data: error.response?.data || error.message || 'Unknown error',
    };
  }
};

export default DeleteMeetingStatusRedis;
